import { C, font, Drawer, Chip, eyebrow } from "../components/ui.jsx";
import { RECIPES, MODEL_QUALITY } from "../lib/recipes.js";

// Read-only list of the curated recipes. Admin create/edit is a later phase (the
// recipes move to Firestore in Phase 2); for now this shows what's available.
export default function RecipesPanel({ onClose, onUseRecipe }) {
  return (
    <Drawer title="Recipes" subtitle="Curated processing pipelines" onClose={onClose}>
      <div style={{ ...eyebrow, marginBottom: 10 }}>{RECIPES.length} recipes</div>
      {RECIPES.map((r) => (
        <div
          key={r.id}
          style={{
            background: C.surface,
            border: `1px solid ${C.border}`,
            borderRadius: 8,
            padding: 16,
            marginBottom: 12,
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
            <div style={{ fontSize: 14, fontWeight: 500, color: C.text }}>{r.name}</div>
            <Chip color={C.amber}>{MODEL_QUALITY[r.quality]}</Chip>
          </div>
          <p style={{ fontSize: 12, color: C.muted, lineHeight: 1.5, margin: "6px 0 10px" }}>{r.description}</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {r.variants.map((v) => (
              <div key={v.name} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, color: C.text }}>
                <span style={{ fontWeight: 500, minWidth: 42 }}>{v.name}</span>
                <span style={{ color: C.muted }}>{v.tris} tris · {v.texture} texture</span>
                <span style={{ marginLeft: "auto", display: "flex", gap: 4 }}>
                  {v.formats.map((f) => <Chip key={f} color={C.muted}>{f}</Chip>)}
                </span>
              </div>
            ))}
          </div>
          {onUseRecipe && (
            <button
              onClick={() => onUseRecipe(r.id)}
              style={{
                marginTop: 12,
                width: "100%",
                padding: "8px 12px",
                background: "transparent",
                color: C.amber,
                border: `1px solid ${C.amber}66`,
                borderRadius: 6,
                fontSize: 12,
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: font,
              }}
            >
              Use this recipe →
            </button>
          )}
        </div>
      ))}
    </Drawer>
  );
}
